$(document).ready(function () {
    if ($(".c-guideline-item-page").length > 0) {
      // scope of current accordion
      $(".c-guideline-item-page").each(function (e) {
        // clicking on accordion-toggle
        var accordionTriggers = $(this).find(
          ".c-guideline-item-page-item__tease"
        );
  
        accordionTriggers.on("click", function (e) {
          //Expand or collapse this panel
          if ($(this).hasClass("open")) {
            $(this).removeClass("open");
            $(this).children(".c-guideline-item-page-item__tease .c-guideline-item-page-arrow").removeClass("open");
            $(this).children(".c-guideline-item-page-item__tease .c-guideline-item-page-plus").removeClass("open");
            $(this).siblings(".c-guideline-item-page-item__content-wrapper").slideUp("fast");
          } else {
            $(this).addClass("open");
            $(this).children(".c-guideline-item-page-item__tease .c-guideline-item-page-arrow").addClass("open");
            $(this).children(".c-guideline-item-page-item__tease .c-guideline-item-page-plus").addClass("open");
            $(this).siblings(".c-guideline-item-page-item__content-wrapper").slideDown("fast");
          }
        });
      });
  
      $(".c-guideline-item-page__expand").on("click", function (e) {
        var siblings = $(this).siblings(".c-guideline-item-page-item");
  
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
          $(this).text("Expand All");
  
          siblings.each(function (e) {
            $(this).find(".c-guideline-item-page-arrow").removeClass("open");
            $(this).find(".c-guideline-item-page-plus").removeClass("open");
            $(this).children(".c-guideline-item-page-item__tease").removeClass("open");
            $(this).children(".c-guideline-item-page-item__content-wrapper").slideUp("fast");
          });
          //each
        } else {
          $(this).addClass("open");
          $(this).text("Collapse All");
  
          siblings.each(function (e) {
            $(this).find(".c-guideline-item-page-arrow").addClass("open");
            $(this).find(".c-guideline-item-page-plus").addClass("open");
            $(this).children(".c-guideline-item-page-item__tease").addClass("open");
            $(this).children(".c-guideline-item-page-item__content-wrapper").slideDown("fast");
            $(this);
          });
          //each
        }
      });
    }
  
    var hashValue = window.location.hash.substring(1);
  
    if (hashValue) {
      var escapedHash = $.escapeSelector(hashValue); // escape +, spaces, etc.

      let item = $(
        '.c-guideline-item-page-item[data-id="' + escapedHash + '"] .c-guideline-item-page-item__tease'
      );
  
      // check it exists before scrolling
      if (item.length) {
        $("html, body").animate({
          scrollTop: parseInt($(item).offset().top),
        });
    
        $(item).addClass("open");
        $(item)
          .children(
            ".c-guideline-item-page-item__tease .c-guideline-item-page-arrow"
          )
          .addClass("open");
        $(item)
          .siblings(".c-guideline-item-page-item__content-wrapper")
          .slideDown("fast");
      }
    }
    
  });
  